import React from 'react';
import { Badge as MuiBadge } from '@mui/material';

interface NavCountBadgeProps {
  readonly count: number;
  /** Counts above this render as "N+". */
  readonly max?: number;
  readonly children: React.ReactNode;
}

/**
 * The unread-count badge on a sidebar nav icon.
 *
 * Anchored to the icon's right edge. A left anchor centres the badge on the
 * icon's left edge, leaving half of it outside the icon box -- and a nav icon
 * sits close enough to the sidebar's edge that a wide count like "99+" was cut
 * off by it. Growing toward the label instead means there is always room, and
 * it matches the binders and bullpen badges, which already take MUI's default.
 */
export const NavCountBadge = ({
  count,
  max = 99,
  children,
}: Readonly<NavCountBadgeProps>) => (
  <MuiBadge
    badgeContent={count}
    max={max}
    color="error"
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    {children}
  </MuiBadge>
);

export default NavCountBadge;
